export default __webpack_public_path__ + "static/media/free-year.1432ed88.png";